import React from "react"
import styled, { css } from "styled-components"
import Img from "gatsby-image"
import { Link } from "gatsby"

function Logo({
  color,
  width,
  link,
}: {
  color?: string
  width?: string
  link?: string
}) {
  const defaultColor = "#2BCBBA"

  const svg = (
    <svg
      width={width ? width : "543"}
      height={width ? (+width * 175) / 543 : "175"}
      viewBox="0 0 543 175"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M76.5 175L0 131.551V43.4492L76.5 0L153 43.4492V131.551L76.5 175ZM76.5 107.754L62.5362 115.687V131.773L76.5 139.706L90.4638 131.773V115.687L76.5 107.754ZM76.5 14.1711L12.4271 50.5834V87.4332H140.573V50.5834L76.5 14.1711Z"
        fill={color ? color : defaultColor}
      />
      <path
        d="M281.933 91.5806C281.933 100.329 280.386 107.999 277.294 114.591C274.201 121.183 269.766 126.269 263.988 129.85C258.251 133.43 251.659 135.221 244.213 135.221C236.848 135.221 230.277 133.451 224.499 129.911C218.721 126.371 214.245 121.325 211.071 114.774C207.897 108.182 206.29 100.614 206.249 92.0688V87.6743C206.249 78.9259 207.816 71.2355 210.949 64.603C214.123 57.9299 218.578 52.8232 224.315 49.2832C230.093 45.7025 236.685 43.9121 244.091 43.9121C251.496 43.9121 258.068 45.7025 263.805 49.2832C269.583 52.8232 274.039 57.9299 277.172 64.603C280.346 71.2355 281.933 78.9056 281.933 87.6133V91.5806ZM263.378 87.5522C263.378 78.2342 261.71 71.1541 258.373 66.312C255.036 61.4699 250.276 59.0488 244.091 59.0488C237.947 59.0488 233.206 61.4495 229.87 66.251C226.533 71.0117 224.844 78.0104 224.804 87.2471V91.5806C224.804 100.654 226.472 107.694 229.809 112.699C233.145 117.704 237.947 120.206 244.213 120.206C250.357 120.206 255.077 117.805 258.373 113.004C261.669 108.162 263.337 101.122 263.378 91.8857V87.5522ZM310.314 67.96L310.863 75.5894C315.583 69.6893 321.911 66.7393 329.845 66.7393C336.844 66.7393 342.052 68.7941 345.47 72.9038C348.888 77.0135 350.638 83.1577 350.719 91.3364V134H333.08V91.7637C333.08 88.0202 332.266 85.3143 330.639 83.646C329.011 81.937 326.305 81.0825 322.521 81.0825C317.557 81.0825 313.834 83.1984 311.352 87.4302V134H293.712V67.96H310.314ZM394.542 135.221C384.858 135.221 376.964 132.25 370.861 126.31C364.798 120.369 361.767 112.455 361.767 102.567V100.858C361.767 94.2254 363.048 88.305 365.612 83.0967C368.175 77.8477 371.797 73.8193 376.476 71.0117C381.196 68.1634 386.567 66.7393 392.589 66.7393C401.623 66.7393 408.723 69.5876 413.891 75.2842C419.099 80.9808 421.703 89.0578 421.703 99.5151V106.717H379.65C380.22 111.03 381.929 114.489 384.777 117.093C387.666 119.697 391.308 121 395.702 121C402.497 121 407.807 118.538 411.632 113.614L420.299 123.319C417.654 127.062 414.074 129.992 409.557 132.108C405.041 134.183 400.036 135.221 394.542 135.221ZM392.528 81.0215C389.029 81.0215 386.181 82.2015 383.983 84.5615C381.827 86.9215 380.443 90.2988 379.833 94.6934H404.369V93.2896C404.288 89.3833 403.23 86.3722 401.195 84.2563C399.161 82.0998 396.272 81.0215 392.528 81.0215ZM452.404 134H434.093V45.1328H452.404V134ZM469.433 134V45.1328H496.776C504.589 45.1328 511.567 46.9028 517.711 50.4429C523.896 53.9422 528.718 58.9471 532.177 65.4575C535.635 71.9272 537.365 79.2922 537.365 87.5522V91.6416C537.365 99.9017 535.656 107.246 532.238 113.675C528.861 120.104 524.079 125.089 517.895 128.629C511.71 132.169 504.731 133.959 496.959 134H469.433ZM487.743 59.9644V119.291H496.593C503.755 119.291 509.228 116.951 513.012 112.271C516.796 107.592 518.729 100.899 518.81 92.1909V87.4912C518.81 78.458 516.938 71.6221 513.195 66.9834C509.451 62.304 503.979 59.9644 496.776 59.9644H487.743Z"
        fill={color ? color : defaultColor}
      />
    </svg>
  )

  if (link) {
    return <LogoLink to={link}>{svg}</LogoLink>
  }

  return svg
}

export { Logo }

const LogoLink = styled(Link)`
  font-size: ${props => props.theme.fontSizes.xl3};
  font-weight: 600;
  text-decoration: none;
  color: ${props => props.theme.colors.primary};
  display: flex;
  align-content: center;
`
